/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react"
import { Helmet } from 'react-helmet'
import { useSelector } from 'react-redux'
import { Nav, TopNav } from '../../components'
import { Container } from './styles'
import reportsApi from '../../../services/reports'
import t from "../../../config/translate"
import { DateRange, Table } from '../../../shared_components'
import moment from "moment"
import generatePagOptions from '../../../utils/generatePageOptions'

function ReportPayamentTypeSale() {
	const CompanyID = useSelector(state => state.auth.authedStore.CompanyID)
	const whitelabel_name = useSelector(state => state.theme.whitelabel_name)
	const pageTitle = 'Listagem de Vendas - Tipo de pagamento'

	const [totalRows, setTotalRows] = useState(10)
	const [perPageOptions, setPerPageOptions] = useState([5, 10, 15, 20, 30, 40])
	const [loading, setLoading] = useState(false)

	const [dateIni, setDateIni] = useState(moment())
	const [dateEnd, setDateEnd] = useState(moment())
	const [perPage, setPerPage] = useState(10)
	const [sales, setSales] = useState([])

	const getSales = (CompanyID, dateIni, dateEnd, page, perPage) => {
		setLoading(true)
		const initialDateFormated = moment(dateIni).format("YYYY-MM-DD")
		const finalDateFormated = moment(dateEnd).format("YYYY-MM-DD")

		reportsApi.getPayamentTypeSale(CompanyID, initialDateFormated, finalDateFormated, page, perPage)
			.then(rst => {
				setSales(rst.data.sales)
				setTotalRows(rst.data.totalRows)
				setPerPageOptions(generatePagOptions(rst.data.totalRows))
				setLoading(false)
			})
			.catch(() => {
				setLoading(false)
			})
	}

	useEffect(() => {
		getSales(CompanyID, dateIni, dateEnd, 1, perPage)
		return () => setSales([])
	}, [])

	const handlePageChange = (page) => {
		getSales(CompanyID, dateIni, dateEnd, page, perPage)
	}

	const handlePerRowsChange = async (newPerPage, page) => {
		getSales(CompanyID, dateIni, dateEnd, page, newPerPage)
		setPerPage(newPerPage)
	}

	const updateRange = () => {
		getSales(CompanyID, dateIni, dateEnd, 1, perPage)
	}

	const createRow = (row, field) => (
		<div className="table_row">{row[field]}</div>
	)
	const search = {
		show: true,
		searchPlaceHolder: t("search"),
		searchButtonClearText: t("clear"),
	}

	const colums = React.useMemo(
		() => [
			{
				name: <div className="table_header">Local</div>,
				selector: (row) => row["CompanyName"],
				cell: (row) => createRow(row, "CompanyName"),
				sortable: true,
			},
			{
				name: <div className="table_header">Data/Hora</div>,
				selector: (row) => row["DataHora"],
				cell: (row) => createRow(row, "DataHora"),
				sortable: true,
			},
			{
				name: <div className="table_header">POS</div>,
				selector: (row) => row["PropertyNumber"],
				cell: (row) => createRow(row, "PropertyNumber"),
				sortable: true,
			},
			{
				name: <div className="table_header">CPF/CNPJ</div>,
				selector: (row) => row["CpfCnpj"],
				cell: (row) => createRow(row, "CpfCnpj"),
				sortable: true,
			},
			{
				name: <div className="table_header">Identificador</div>,
				selector: (row) => row["Identificador"],
				cell: (row) => createRow(row, "Identificador"),
				sortable: true,
			},
			{
				name: <div className="table_header">Série</div>,
				selector: (row) => row["serienf"],
				cell: (row) => createRow(row, "serienf"),
				sortable: true,
			},
			{
				name: <div className="table_header">Número</div>,
				selector: (row) => row["numnf"],
				cell: (row) => createRow(row, "numnf"),
				sortable: true,
			},
			{
				name: <div className="table_header">Cód. Venda</div>,
				selector: (row) => row["SalePosCodeID"],
				cell: (row) => createRow(row, "SalePosCodeID"),
				sortable: true,
			},
			{
				name: <div className="table_header">Forma de Pagamento</div>,
				selector: (row) => row["Name"],
				cell: (row) => createRow(row, "Name"),
				sortable: true,
			},
			{
				name: <div className="table_header">Tipo</div>,
				selector: (row) => row["Name"],
				cell: (row) => createRow(row, "Name"),
				sortable: true,
			},
			{
				name: <div className="table_header">Autorização</div>,
				selector: (row) => row["TEFAutorizacao"],
				cell: (row) => createRow(row, "TEFAutorizacao"),
				sortable: true,
			},
			{
				name: <div className="table_header">Portador</div>,
				selector: (row) => row["PnamePerson"],
				cell: (row) => createRow(row, "PnamePerson"),
				sortable: true,
			},
			{
				name: <div className="table_header">Empresa</div>,
				selector: (row) => row["PnameCompany"],
				cell: (row) => createRow(row, "PnameCompany"),
				sortable: true,
			},
			{
				name: <div className="table_header">Rede</div>,
				selector: (row) => row["TEFRede"],
				cell: (row) => createRow(row, "TEFRede"),
				sortable: true,
			},
			{
				name: <div className="table_header">Cartão</div>,
				selector: (row) => row["TEFCartao"],
				cell: (row) => createRow(row, "TEFCartao"),
				sortable: true,
			},
			{
				name: <div className="table_header">Valor</div>,
				selector: (row) => row["PaidAmount"],
				cell: (row) => createRow(row, "PaidAmount"),
				sortable: true,
			}
		],
		[]
	)

	return (
		<Container>
			<Helmet><title>{pageTitle} | {whitelabel_name}</title></Helmet>
			<Nav />
			<div className='content_container'>
				<TopNav pageTitle={pageTitle} />
				<div className="form_container">
					<div className="table_search_container">
						<DateRange
							initialDate={dateIni}
							finalDate={dateEnd}
							setFinalDate={setDateEnd}
							setInitialDate={setDateIni}
							submit={updateRange}
						/>
					</div>

					<Table
						data={sales}
						colums={colums}
						title={'Vendas por tipo de pagamento'}
						search={search}
						paginationServer={true}
						onChangePage={handlePageChange}
						onChangeRowsPerPage={handlePerRowsChange}
						totalRows={totalRows}
						perPageOptions={perPageOptions}
						loading={loading}
					/>
				</div>
			</div>
		</Container>
	)
}

export default ReportPayamentTypeSale